<template>
    <div>
        <Row type="flex" justify="space-between" class="code-row-bg">
            <Col span="3">{{ invoice.loadDate }}</Col>

            <Col span="3">
            <div v-if="invoice.containerCode != ''">
                P. {{ invoice.containerCode }}
            </div>
            </Col>
            <Col span="4" align="left">{{ invoice.description }}</Col>
            <Col v-if="invoice.receivableRemainingIdr !== 0" span="3" align="right">{{ invoice.receivableRemaining |
                currency
            }} ({{ invoice.receivableRemainingIdr | numberFormatted }})</Col>
            <Col v-else span="3" align="right">{{ invoice.receivableRemaining | numberFormatted }}</Col>
        </Row>
    </div>
</template>

<script>
const numeral = require('numeral');

export default {
    props: {
        invoice: Object
    },
    data: () => ({

    }),
    created() {

    },
    filters: {
        currency: function (value) {

            if (!value) return ''
            return numeral(value).format('0,0.00')
        }
    }
}


</script>
<style></style>


// WEBPACK FOOTER //
// cInvoiceUnSettledByMarkingRow.vue?3cc2a01e